module.exports = __webpack_public_path__ + "static/media/012.d4f1f684.jpg";